import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const ServiceAreasTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return <LmsTable actionButtons={actionsButtons} apiSuffix="/vendors/list-work-areas" deleteSuffix="/vendors/delete-work-areas" />;
};

const addVendorServiceAreasFormFields = (myForm, isEdit = false) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Vendor Organization", "/vendors/list-organizations", { required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("State", "/orgs/list-states", { required: true })]);
  myForm.addCenteredGroup([
    myForm.getDropdownField("County", "/vendors/list-available-counties", {
      name: isEdit ? "countyId" : "countyIds",
      dropdownMultiple: !isEdit,
      required: true,
      optionalDropdownQueries: [
        { query: "stateId", fieldName: "stateId" },
        { query: "organizationId", fieldName: "vendorOrganizationId" }
      ]
    })
  ]);

  if (isEdit) {
    myForm.addCenteredGroup([myForm.getCheckboxField("Is Active", { inline: true } )]);
    myForm.addCenteredGroup([myForm.getTextareaField("Description" )]);
  }

  return myForm;
};

const AddServiceAreasForm = () => {
  const myForm = addVendorServiceAreasFormFields(
    new BCFormController({}, { submitSuffix: "/vendors/add-work-area", blankWidth: 4 })
  );

  const formActions = ["save-new", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} />;
};

const EditServiceAreasForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`/vendors/get-work-area/${id}`, {skipCache: true});
  const myForm = addVendorServiceAreasFormFields(new BCFormController(data, {
    deleteSuffix: "/vendors/delete-work-areas",
    submitSuffix: "/vendors/update-work-area",
    blankWidth: 4
  }), true);

  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} isLoading={isLoading} error={error} />;
};

const LmsVendorsServiceAreas = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <ServiceAreasTable />}
      {isAdd && <AddServiceAreasForm />}
      {isEdit && <EditServiceAreasForm id={id} />}
    </>
  );
};

export default LmsVendorsServiceAreas;